import { useParams, Link } from 'react-router-dom'
import axios from 'axios'
import { useAuthHeader, useAuthUser } from 'react-auth-kit'
import { useState, useEffect } from 'react'
import Spinner from '../../usables/small/Spinner'
import ClosingAlert from '../../usables/Alert'
import Card from '../../usables/small/Card'
import Modal from '../../usables/Modal'
import Input from '../../usables/small/Input'
// import Button from '../../usables/small/ButtonReal'
import Select from 'react-select'

export default function  Guardian() {
  const { id } = useParams();
  const auth  = useAuthHeader()
  const authUser  = useAuthUser()
  const [guardian, setGuardian] = useState({})
  const [dataLoaded, setDataLoaded] = useState({done: false, sucssess: false, items: 0})
  const [formData, setFormData] = useState({name: '', lastname: '', email: '', phone: ''})
  // const [formDataS, setFormDataS] = useState({student_id: '', name: '', lastname: '', email: '', phone: ''})
  const [formDataGC, setFormDataGC] = useState({student_id: '', guardian_id: id})
  const [studentList, setStudentList] = useState([])
  const [errorMsg, setErrorMsg] = useState('Nepavyko įrašyti reikšmės')
  const [showError, setShowError] = useState(false)
  // const modal = createRef()

  const config = {
    headers: {
      Authorization: auth()
    }
  }

  const updatePerson = () => {
    axios.patch(process.env.REACT_APP_API + `/people/${guardian.person.id}`, formData, config)
      .then((res)=>{
        if(res.status === 200){
          var guard = {...guardian}
          guard.person = res.data.person
          setGuardian(guard)
        }
      })
      .catch((err) => {
        setErrorMsg(err.response.data.message)
        setShowError(true)
      })
    }

  const attachStudent = () => {
    axios.post(process.env.REACT_APP_API + '/guardian/attach', formDataGC, config)
      .then((res)=>{
        if(res.status === 200){
          window.location.reload()
        }
      })
      .catch((err) => {
        if(err.response.data.message.split(' ')[0] === 'SQLSTATE[23000]:') {
          setErrorMsg('Moksleivis jau priskirtas šiam globėjui')
          setShowError(true)
        }
        else {
          setErrorMsg(err.response.data.message)
          setShowError(true)
        }
      })
    }

  const detachStudent = (data) => {
    axios.post(process.env.REACT_APP_API + '/guardian/detach', data, config)
    .then((res)=>{
      if(res.status === 200){
        window.location.reload()
      }
    })
    .catch((err) => {
      setErrorMsg(err.data.message)
      setShowError(true)
    })
  }

  useEffect(() => {
    axios.get(process.env.REACT_APP_API + `/guardian/${id}`, config)
    .then(res => {
      if(res.status === 200){
        setGuardian(res.data.guardian)
        setFormData({name: res.data.guardian.person.name, lastname: res.data.guardian.person.lastname, email: res.data.guardian.person.email, phone: (res.data.guardian.person.phone === null) ? '' : res.data.guardian.person.phone})
        setDataLoaded({done: true, sucssess: true, items: 1})
      }
      axios.get(process.env.REACT_APP_API + '/student', config)
      .then(res => {
        if(res.status === 200){
          setStudentList([]) //! Pašalinti prieš buildinant
          res.data.forEach((data) => {
            setStudentList(student => [...student, data])
            // setDataLoaded({done: true, sucssess: true, items: res.data.length})
          })
        }
      })
      .catch(err => {
        setStudentList([]) //! Pašalinti prieš buildinant
        setStudentList(people => [...people, err.response.data])
        // setDataLoaded({done: true, sucssess: false, items: 0})
      })
    })
    .catch(err => {
      setGuardian([]) //! Pašalinti prieš buildinant
      //console.log(err.response.data)
      setGuardian(err.response.data)
      setDataLoaded({done: true, sucssess: false, items: 0})
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
    {dataLoaded.sucssess ? <h2>{guardian.person.name + ' ' + guardian.person.lastname}</h2> : null}
    <ClosingAlert type='error' message={errorMsg} show={showError} updateState={(value) => {setShowError(value)}} />
      {!dataLoaded.done
      ? <Spinner />
      : dataLoaded.sucssess
        ?dataLoaded.items
          ? <>
            {/* {JSON.stringify(guardian)} */}
            <div className="p-10 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 gap-5">
              <Card title='Pagrindinė informacija'>
                <ul className='divide-y divide-gray-200'>
                  <li className="py-3 sm:py-4">
                    <div className="flex items-center space-x-4">
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 truncate ">
                          Vardas
                        </p>
                      </div>
                      <div className="inline-flex items-center text-base font-semibold text-gray-900 ">
                        {guardian.person.name}
                      </div>
                    </div>
                  </li>
                  <li className="py-3 sm:py-4">
                    <div className="flex items-center space-x-4">
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 truncate ">
                          Pavardė
                        </p>
                      </div>
                      <div className="inline-flex items-center text-base font-semibold text-gray-900 ">
                        {guardian.person.lastname}
                      </div>
                    </div>
                  </li>
                  <li className="py-3 sm:py-4">
                    <div className="flex items-center space-x-4">
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 truncate ">
                          El. paštas
                        </p>
                      </div>
                      <div className="inline-flex items-center text-base font-semibold text-gray-900 ">
                        {(guardian.person.email !== null) ? guardian.person.email : 'nėra'}
                      </div>
                    </div>
                  </li>
                  <li className="py-3 sm:py-4">
                    <div className="flex items-center space-x-4">
                      {/* <div class="flex-shrink-0">
                        <img class="w-8 h-8 rounded-full" src="/docs/images/people/profile-picture-1.jpg" alt="Neil image" />
                      </div> */}
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 truncate "> {/* dark:text-white */}
                          Telefonas
                        </p>
                        {/* <p class="text-sm text-gray-500 truncate "> {/* dark:text-gray-400 */}
                          {/* email@windster.com
                        </p> */}
                      </div>
                      <div className="inline-flex items-center text-base font-semibold text-gray-900 "> {/* dark:text-white */}
                        {(guardian.person.phone !== null) ? guardian.person.phone : 'nėra'}
                      </div>
                    </div>
                  </li>
                </ul>
                {authUser().roles.admin &&
                <Modal btnText='Redaguoti' title='Redaguoti' saveText='Išsaugoti' submitFunction={() => updatePerson()}>
                  <div className='pt-5'>
                    <Input
                      label='Vardas'
                      name='name'
                      type='text'
                      value={formData.name}
                      onChange={(e)=>setFormData({...formData, name: e.target.value})}
                      />
                    <Input
                      label='Pavardė'
                      name='lastname'
                      type='text'
                      value={formData.lastname}
                      onChange={(e)=>setFormData({...formData, lastname: e.target.value})}
                      />
                    <Input
                      label='El. paštas'
                      name='email'
                      type='email'
                      value={formData.email}
                      onChange={(e)=>setFormData({...formData, email: e.target.value})}
                      />
                    <Input
                      label='Telefonas'
                      name='phone'
                      type='tel'
                      value={formData.phone}
                      onChange={(e)=>setFormData({...formData, phone: e.target.value})}
                      />
                  </div>
                </Modal>}
              </Card>
              <Card title='Moksleiviai'>
                <ul className='divide-y divide-gray-200'>
                  {(guardian.student.length !== 0)
                    ? guardian.student.map((student) => {
                      return (
                        <li key={student.id} className="py-3 sm:py-4">
                          <div className="flex items-center space-x-4">
                            <div className="flex-1 min-w-0">
                              <p className="text-sm font-medium text-gray-900 truncate "> {/* dark:text-white */}
                                {student.person.name + ' ' + student.person.lastname}
                              </p>
                            </div>
                            <div className="inline-flex items-center text-base font-semibold text-gray-900 "> {/* dark:text-white */}
                              <Link className='text-violet-500 hover:text-violet-700' to={'/dashboard/students/' + student.id}>Daugiau</Link>&nbsp;
                              {authUser().roles.admin && 
                              <span className='text-red-500 hover:text-red-700 cursor-pointer' onClick={() => {
                                setFormDataGC({...formDataGC, student_id: student.id})
                                detachStudent({...formDataGC, student_id: student.id})
                              }}>Naikinti</span>}
                            </div>
                          </div>
                        </li>
                      )
                    })
                    : 'Moksleivių nerasta'
                  }
                  
                </ul>
                {authUser().roles.admin && 
                <Modal btnText='Pridėti' title='Pridėti moksleivį' saveText='Išsaugoti' submitFunction={() => attachStudent()}>
                  <div className='pt-1'>
                  <label className='text-gray-500' htmlFor="class">Moksleivis</label>
                  <Select 
                    name='class'
                    onChange={(e)=>setFormDataGC({...formDataGC, student_id: e.value})} 
                    options={
                    studentList.map(student => {
                      return ({ value: student.id, label: student.person.name + ' ' + student.person.lastname })
                    })
                  } />
                  </div>
                </Modal>}
              </Card>
            </div>
          </>
          : <ClosingAlert type='warning' message='Nerastas jokia informacija' />
        : <ClosingAlert type='error' message='Vartotojs nerastas' />
      }
    </>
  )
}